import React, { useEffect, useState } from "react";
import Navbar from "../../../Components/Navbar";
import { useNavigate } from "react-router-dom";
import { apiPostFormData, Create_Api } from "../../../API/Api_Url";
import { toast } from "react-toastify";
import { ArrowLeft, Upload } from "lucide-react";
import { State, City as Citie } from "country-state-city";

function SupplierSignUp() {
    const navigate = useNavigate()
    const [IsUploading, setIsUploading] = useState(false);
    const [step, setStep] = useState(1);

    const [companyName, setCompanyName] = useState("");
    const [contactPerson, setContactPerson] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [companyAddress, setCompanyAddress] = useState("");
    const [password, setPassword] = useState("");
    const [subRole, setSubRole] = useState("");
    const [location, setLocation] = useState("");
    const [city, setCity] = useState("");
    const [materialTypesSupplied, setMaterialTypesSupplied] = useState([]);
    const [brandsSupplied, setBrandsSupplied] = useState([]);
    const [deliveryTimeForMaterials, setDeliveryTimeForMaterials] = useState("");
    const [PANCard, setPANCard] = useState(null);
    const [GST, setGST] = useState(null);

    const [bankDetails, setbankDetails] = useState({
        AccountHolderName: "",
        BankName: "",
        AccountNumber: "",
        IFSCCode: "",
        BranchName: "",
        UPIId: "",
    });


    const validateStep = () => {
        if (step === 1) {
            if (!companyName || !phoneNumber || !emailAddress || !password) {
                toast.error("Please fill all required fields in Basic Information.");
                return false;
            }
        }
        if (step === 4) {
            if (!PANCard || !GST) {
                toast.error("Please upload required documents (PAN Card & GST).");
                return false;
            }
        }

        return true;
    };

    const SupplierRole = [
        'Brick / Block Supplier',
        'Steel Supplier',
        'Cement & Aggregate Vendor',
        'Sand & Gravel Supplier',
        'JCB / Excavation Contractor',
        'Water Tanker Supplier',
        'Lift Vendor'
    ];

    const [SelectedState, setSelectedState] = useState("");
    const [SelectedDistrict, setSelectedDistrict] = useState("");

    const [Districts, setDistricts] = useState([]);
    const [Cities, setCities] = useState([]);

    useEffect(() => {
        if (SelectedState) {
            const stateCities = Citie.getCitiesOfState("IN", SelectedState);

            const uniqueDistricts = [
                ...new Set(stateCities.map((c) => c.stateCode + "-" + c.name)),
            ].map((key) => {
                const parts = key.split("-");
                return { name: parts[1], stateCode: parts[0] };
            });

            setDistricts(uniqueDistricts);
            setSelectedDistrict("");
            setCities([]);
        }
    }, [SelectedState]);

    useEffect(() => {
        if (SelectedDistrict) {
            const allCities = Citie.getCitiesOfState("IN", SelectedState);

            const filtered = allCities.filter(
                (city) => city.name === SelectedDistrict
            );

            setCities(filtered);
        }
    }, [SelectedDistrict]);

    const handleSubmit = async () => {
        const formData = new FormData();
        formData.append("companyName", companyName);
        formData.append("contactPerson", contactPerson);
        formData.append("phoneNumber", phoneNumber);
        formData.append("emailAddress", emailAddress);
        formData.append("companyAddress", companyAddress);
        formData.append("password", password);
        formData.append("SubRole", subRole);
        formData.append("Location", location);
        formData.append("City", city);

        formData.append("materialTypesSupplied", JSON.stringify(materialTypesSupplied));
        formData.append("brandsSupplied", JSON.stringify(brandsSupplied));
        formData.append("deliveryTimeForMaterials", SelectedDistrict);


        if (PANCard) formData.append("PANCard", PANCard);
        if (GST) formData.append("GST", GST);

        Object.keys(bankDetails).forEach((key) => {
            formData.append(`Bankdetails[${key}]`, bankDetails[key]);
        });

        try {
            setIsUploading(true);
            const response = await apiPostFormData(`api/material-supplier/register1`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response?.statusCode === 200) {
                localStorage.removeItem("UserType");
                localStorage.removeItem("user");
                localStorage.removeItem("userToken");
                localStorage.setItem("UserType", "supplier");
                localStorage.setItem("user", JSON.stringify(response?.data?.supplier));
                localStorage.setItem("userToken", response?.data?.tokens?.accessToken);
                toast.success(response?.message);
                navigate("/");
                setTimeout(() => window.location.reload(), 3000);
            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.error(error);
        } finally {
            setIsUploading(false);
        }
    };


    return (
        <>
            <Navbar />
            <div className="AllSignupPadding">
                <div className="flex justify-center">
                    <div className="w-full max-w-4xl bg-white rounded-2xl shadow-xl border border-gray-200 p-10">
                        <div className="relative flex items-center mb-10">
                            <button
                                onClick={() => navigate(-1)}
                                className="absolute left-0 text-gray-700 hover:text-black transition"
                            >
                                <ArrowLeft size={26} />
                            </button>
                            <h1 className="text-3xl font-extrabold text-gray-800 text-center w-full">
                                Material Supplier Signup
                            </h1>
                        </div>
                        <div className="flex items-center justify-center mb-8 gap-2 sm:gap-4 w-full px-4 overflow-x-auto">
                            {[1, 2, 3, 4, 5].map((num, index) => (
                                <React.Fragment key={num}>
                                    <div
                                        className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center font-bold text-sm sm:text-base ${step >= num
                                            ? "bg-gradient-to-r from-blue-600 to-red-500 text-white"
                                            : "bg-gray-200 text-gray-600"
                                            }`}
                                    >
                                        {num}
                                    </div>
                                    {index < 4 && (
                                        <div
                                            className={`flex-1 h-1 sm:h-1.5 ${step > num
                                                ? "bg-gradient-to-r from-blue-600 to-red-500"
                                                : "bg-gray-300"
                                                }`}
                                        />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>



                        <h2 className="text-2xl font-bold text-center mb-6">
                            {step === 1 && "Basic Information"}
                            {step === 2 && "Professional Details"}
                            {step === 3 && "Materials, Brands, Delivery"}
                            {step === 4 && "PAN & GST Upload"}
                            {step === 5 && " Bank Details"}
                        </h2>
                        {step === 1 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Company Name <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        placeholder="Enter company name"
                                        value={companyName}
                                        onChange={(e) => setCompanyName(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter your name"
                                        value={contactPerson}
                                        onChange={(e) => setContactPerson(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Email <span className="text-red-500">*</span></label>
                                    <input
                                        type="email"
                                        placeholder="Enter email"
                                        value={emailAddress}
                                        onChange={(e) => setEmailAddress(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Password <span className="text-red-500">*</span></label>
                                    <input
                                        type="password"
                                        placeholder="Enter password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Phone <span className="text-red-500">*</span></label>
                                    <input
                                        type="number"
                                        placeholder="Enter phone number"
                                        value={phoneNumber}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                            </div>
                        )}

                        {step === 2 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Supply</label>
                                    <select
                                        value={subRole}
                                        onChange={(e) => setSubRole(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    >
                                        <option value="">Select Supply</option>
                                        {SupplierRole?.map((role, index) => (
                                            <option key={index} value={role}>
                                                {role}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">State</label>
                                    <select
                                        value={SelectedState}
                                        onChange={(e) => setSelectedState(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                    >
                                        <option value="">Select State</option>
                                        {State?.getStatesOfCountry("IN")?.map((st) => (
                                            <option key={st.isoCode} value={st?.isoCode}>
                                                {st?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">District</label>
                                    <select
                                        value={SelectedDistrict}
                                        onChange={(e) => setSelectedDistrict(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                    >
                                        <option value="">Select District</option>
                                        {Districts?.map((d, idx) => (
                                            <option key={idx} value={d?.name}>
                                                {d?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">City</label>
                                    <select
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                    >
                                        <option value="">Select City</option>
                                        {Cities?.map((c, idx) => (
                                            <option key={idx} value={c?.name}>
                                                {c?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Pincode</label>
                                    <input
                                        type="text"
                                        placeholder="Enter Pincode"
                                        value={location}
                                        onChange={(e) => setLocation(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Address</label>
                                    <input
                                        type="text"
                                        placeholder="Enter address"
                                        value={companyAddress}
                                        onChange={(e) => setCompanyAddress(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                            </div>
                        )}
                        {step === 3 && (
                            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                                <div className="col-span-1 md:col-span-2">
                                    <label className="block mb-2 font-medium text-gray-700">Materials</label>
                                    <input
                                        type="text"
                                        placeholder="Enter materials (comma separated)"
                                        value={materialTypesSupplied}
                                        onChange={(e) => setMaterialTypesSupplied(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div className="col-span-1 md:col-span-2">
                                    <label className="block mb-2 font-medium text-gray-700">Brands</label>
                                    <input
                                        type="text"
                                        placeholder="Enter brands"
                                        value={brandsSupplied}
                                        onChange={(e) => setBrandsSupplied(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                {/* <div>
                                    <label className="block mb-2 font-medium text-gray-700">Supply Area</label>
                                    <input
                                        type="text"
                                        placeholder="Supply Area"
                                        value={deliveryTimeForMaterials}
                                        onChange={(e) => setDeliveryTimeForMaterials(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div> */}
                            </div>
                        )}


                        {step === 4 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Upload PAN Card</label>
                                    <div
                                        className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed rounded-2xl cursor-pointer hover:border-blue-500 transition relative overflow-hidden"
                                        onClick={() => document.getElementById("panUpload").click()}
                                    >
                                        {PANCard ? (
                                            PANCard.type.startsWith("image/") ? (
                                                <img
                                                    src={URL.createObjectURL(PANCard)}
                                                    alt="Preview"
                                                    className="object-contain h-full w-full"
                                                />
                                            ) : (
                                                <p className="text-sm text-gray-600">{PANCard.name}</p>
                                            )
                                        ) : (
                                            <>
                                                <Upload />
                                                <p className="text-gray-500">Click to upload</p>
                                            </>
                                        )}
                                    </div>
                                    <input
                                        type="file"
                                        id="panUpload"
                                        accept=".pdf,.jpg,.png"
                                        onChange={(e) => setPANCard(e.target.files[0])}
                                        className="hidden"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Upload GST Certificate</label>
                                    <div
                                        className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed rounded-2xl cursor-pointer hover:border-blue-500 transition relative overflow-hidden"
                                        onClick={() => document.getElementById("gstUpload").click()}
                                    >
                                        {GST ? (
                                            GST.type.startsWith("image/") ? (
                                                <img
                                                    src={URL.createObjectURL(GST)}
                                                    alt="Preview"
                                                    className="object-contain h-full w-full"
                                                />
                                            ) : (
                                                <p className="text-sm text-gray-600">{GST.name}</p>
                                            )
                                        ) : (
                                            <>
                                                <Upload />
                                                <p className="text-gray-500">Click to upload</p>
                                            </>
                                        )}
                                    </div>
                                    <input
                                        type="file"
                                        id="gstUpload"
                                        accept=".pdf,.jpg,.png"
                                        onChange={(e) => setGST(e.target.files[0])}
                                        className="hidden"
                                    />
                                </div>
                            </div>
                        )}

                        {step === 5 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Account Holder Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter account holder name"
                                        value={bankDetails.AccountHolderName}
                                        onChange={(e) => setbankDetails({ ...bankDetails, AccountHolderName: e.target.value })}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Bank Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter bank name"
                                        value={bankDetails.BankName}
                                        onChange={(e) => setbankDetails({ ...bankDetails, BankName: e.target.value })}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Account Number</label>
                                    <input
                                        type="text"
                                        placeholder="Enter account number"
                                        value={bankDetails.AccountNumber}
                                        onChange={(e) => setbankDetails({ ...bankDetails, AccountNumber: e.target.value })}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">IFSC Code</label>
                                    <input
                                        type="text"
                                        placeholder="Enter IFSC code"
                                        value={bankDetails.IFSCCode}
                                        onChange={(e) => setbankDetails({ ...bankDetails, IFSCCode: e.target.value })}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Branch Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter branch name"
                                        value={bankDetails.BranchName}
                                        onChange={(e) => setbankDetails({ ...bankDetails, BranchName: e.target.value })}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">UPI ID</label>
                                    <input
                                        type="text"
                                        placeholder="Enter UPI ID"
                                        value={bankDetails.UPIId}
                                        onChange={(e) => setbankDetails({ ...bankDetails, UPIId: e.target.value })}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                            </div>
                        )}
                        <div className="mt-10 flex justify-between">
                            {step > 1 && (
                                <button
                                    onClick={() => setStep(step - 1)}
                                    className="px-6 py-2 rounded-full bg-gray-400 text-white hover:bg-gray-500 transition"
                                >
                                    Back
                                </button>
                            )}

                            {step < 5 ? (
                                <button
                                    onClick={() => {
                                        if (validateStep()) {
                                            setStep(step + 1);
                                        }
                                    }}
                                    className="ml-auto px-8 py-3 rounded-full text-white font-semibold shadow-lg bg-gradient-to-r from-blue-600 to-red-500 hover:opacity-90 transition"
                                >
                                    Next →
                                </button>
                            ) : (
                                <button
                                    onClick={handleSubmit}
                                    disabled={IsUploading}
                                    className={`ml-auto px-8 py-3 rounded-full text-white font-semibold shadow-lg bg-gradient-to-r from-blue-600 to-red-500 hover:opacity-90 transition flex items-center justify-center ${IsUploading ? "opacity-70 cursor-not-allowed" : ""
                                        }`}
                                >
                                    {IsUploading ? (
                                        <svg
                                            className="animate-spin h-5 w-5 text-white"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                        >
                                            <circle
                                                className="opacity-25"
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="currentColor"
                                                strokeWidth="4"
                                            ></circle>
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8v8H4z"
                                            ></path>
                                        </svg>
                                    ) : (
                                        "Submit ✅"
                                    )}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SupplierSignUp;
